import { render, staticRenderFns } from "./properties-component-text.vue?vue&type=template&id=d2cd44fe&scoped=true"
import script from "./properties-component-text.vue?vue&type=script&lang=js"
export * from "./properties-component-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cd44fe",
  null
  
)

export default component.exports